<template>
  <div class="js-collapse accordion__item">
    <button type="button" class="js-collapse-button accordion__header">
      <div class="grid grid--jcStart grid--row grid--inline">
        <div class="grid grid--row grid--aiCenter grid--jcStart">
          <icon-calendar></icon-calendar>
          <p>{{ day | dayToLabel }}</p>
        </div>
        <div class="grid grid--row grid--aiCenter grid--jcStart">
          <icon-clock></icon-clock>
          <p class="text--regular">{{ dailySimulation.time_slot.humanized_slot }}</p>
        </div>
        <p class="text--regular text-right">£{{ (dailySimulation.total / 100) | setDecimals }}</p>
      </div>
    </button>
    <div class="js-collapse-content accordion__content text--regular caption">
      <div v-for="item in dailySimulation.items"
           class="grid grid--jcSpaceBetween">
        <p>{{ item.product.name }} x {{ item.quantity }}</p>
        <p>£{{ item.product.price * item.quantity | setDecimals }}</p>
      </div>
      <div
        v-for="adjustment in dailySimulation.adjustments"
        class="grid grid--jcSpaceBetween">
        <p>{{ adjustment.humanized_type }}</p>
        <p>£{{ (adjustment.amount / 100) | setDecimals }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dailySimulation: {
      type: Object,
      required: true
    },
  },

  computed: {
    day() {
      return moment().day(this.dailySimulation.day_of_week).format('dddd');
    }
  }
}
</script>
